<div class="welcome-page">
    <a href="https://ellesdafrique.fr/museum" target="_top">
        <img class="welcome-page_with-monument" src="assets/img/welcome-page/house-with-monument.png">
        <img class="welcome-page_with-monument-outline" src="assets/img/welcome-page/house-with-monument-outline.png">
    </a>

    <a href="https://museeadn.fr/museum" class="link-to-musee-adn" target="_top">
        <img class="welcome-page_with-monument" src="assets/img/welcome-page/musee-adn-hut.png">
        <!-- <img class="welcome-page_with-monument-outline" src="assets/img/welcome-page/house-with-monument-outline.png"> -->
    </a>

    <a href="https://museephemere.fr/museum" class="link-to-museephemere" target="_top">
        <img src="assets/img/welcome-page/case-museephemere.png" class="welcome-page_house">
        <!-- <img src="assets/img/welcome-page/house-outline.png" class="welcome-page_house-outline"> -->
    </a>
    <!-- <a href="https://museephemere.fr/museum" target="_top">
        <img src="assets/img/welcome-page/house.PNG" class="welcome-page_house">
        <img src="assets/img/welcome-page/house-outline.png" class="welcome-page_house-outline">
    </a> -->
</div>